import { Box, Accordion, AccordionDetails, AccordionSummary } from "@mui/joy";
import { KeyboardArrowDownIcon } from "../../../../../styles/StyledMUI";
import type { LogEntry } from "../../../../../api/followup/Followup.typed";
import DarkTypography from "../../../../common/DarkTypography";
import { colorTokens, textTokens } from "../../../../../styles/globalStyles";

type FollowUpLogsAccordionProps = {
  logs: LogEntry[] | undefined;
};

export default function FollowUpLogsAccordion({ logs }: FollowUpLogsAccordionProps) {
  const logsArray = Array.isArray(logs) ? logs : [];
  if (logsArray.length === 0) return null;

  const hasEntries = logsArray.length > 0;

  return (
    <Accordion
      sx={{
        mb: 3,
        backgroundColor: colorTokens.bg.sheetLight,
        color: textTokens.color.inverse,
        overflow: "hidden",
      }}
      defaultExpanded={false}
    >
      <AccordionSummary indicator={<KeyboardArrowDownIcon />}>
        <DarkTypography level="title-md" sx={{ color: textTokens.color.inverse }}>
          Historique
        </DarkTypography>
      </AccordionSummary>
      <AccordionDetails sx={{ overflow: "hidden" }}>
        <Box sx={{ maxHeight: "200px", overflow: "auto", position: "relative" }}>
          {hasEntries ? (
            logsArray.map((entry, index) => (
              <Box
                key={index}
                sx={{
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <DarkTypography level="body-sm" sx={{ fontStyle: "italic" }}>
                  {entry.message}
                </DarkTypography>
                <DarkTypography
                  level="body-sm"
                  sx={{ color: textTokens.color.onLightSecondary, ml: 2 }}
                >
                  par {entry.user} •{" "}
                  {new Date(entry.timestamp).toLocaleString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </DarkTypography>
              </Box>
            ))
          ) : (
            <DarkTypography level="body-sm">Aucun historique disponible</DarkTypography>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
